
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('div', { 'className': 'garage-container' }, [this.changeButton(function () {
            return _createElement('div', { 'className': 'cm_changeButton' }, _createElement('div', { 'className': 'garage-icon cm_icon_garage__background' }), this.template === 'active' ? _createElement('div', {
                'className': 'active-container cmTemplate_active',
                'key': '92'
            }, 'SHOP PARTS BY VEHICLE', _createElement('div', { 'className': 'cm_vehicle-widget_subtitle' }, 'Enter your vehicle to see only products built to fit across the entire site.')) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'locked-container cmTemplate_locked',
                'key': '339'
            }, _createElement('span', { 'className': 'model' }, this.vehicleString), _createElement('span', { 'className': 'change' }, _translate(`single_vehicle_garage_change`))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.template === 'locked' ? _createElement('div', {
        'className': 'clear-garage cmTemplate_locked',
        'key': '1165'
    }, _createElement('div', {
        'className': 'cm_button',
        'onClick': this.discardVehicle
    }, _createElement('span', {}, _translate(`single_vehicle_garage_clear`)))) : null);
}
        export const componentNames = ["cm:changeButton"]